import React, { useLayoutEffect, useRef, useState } from 'react';
import { classNames } from '@fullstory/util/fmt';
import css from './index.module.scss';

export interface ScrollShadowProps {
  maxHeight: number;
  children?: React.ReactNode;
}

export const ScrollShadow: React.FC<ScrollShadowProps> = ({ maxHeight, children }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [showInset, setShowInset] = useState(false);

  useLayoutEffect(() => {
    if (!wrapperRef.current) return;

    if (wrapperRef.current.getBoundingClientRect().height > maxHeight) {
      setShowInset(true);
    } else setShowInset(false);
  }, [children, maxHeight]);

  return (
    <div style={{ position: 'relative' }}>
      <div
        className={classNames(css.insetShadowContainer, { [css.insetShadow]: showInset })}
        style={{ maxHeight }}
      >
        <div ref={wrapperRef}>{children}</div>
      </div>
    </div>
  );
};
